// @ts-strict-ignore

import type { ContextState, MutationClass } from '../../../models'

export class SetContextMutation implements MutationClass {
  static execute(this: void, state: ContextState, context: Partial<ContextState>): void {
    for (const key in context) {
      state[key] = context[key]
    }
  }
}
